import * as React from "react";
import { forwardRef } from "react";
const SvgIcDataInfo20StatusOk = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { width: 20, height: 20, viewBox: "0 0 20 20", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M10 0C15.5228 0 20 4.47715 20 10C20 15.5228 15.5228 20 10 20C4.47715 20 0 15.5228 0 10C0 4.47715 4.47715 0 10 0ZM8.89941 12.9854L5.70703 9.79297L4.29297 11.207L9.10059 16.0146L16.9014 5.81348L15.3135 4.59863L8.89941 12.9854Z", fill: "#13A813" }));
const ForwardRef = forwardRef(SvgIcDataInfo20StatusOk);
export { ForwardRef as ReactComponent };
